import React, { useState } from 'react';
import {View, Text, Modal } from 'react-native';
import CustomPressable from '../../components/customPressable/customPressable';
import { CHEVRON_RIGHT } from '../../assets';
import { ImageComp } from '../../components/Image/Image';
import { useDispatch } from 'react-redux';
import { checkIsEventModalNeededToOpen } from '../../Redux/Reducers/tableReservationReducer';
import { useTranslation } from 'react-i18next';


const EventModal = (props) => {

  const {
    dailyProgrammeData, 
    getStyles, 
    visible, 
    onClose, 
    setShowExtraFields

  } = props || {};

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [showDetails , setShowDetails] = useState(false);

  if (!dailyProgrammeData || dailyProgrammeData?.length === 0) {
    return null; 
  }

  const eventData = dailyProgrammeData[0];

  const handlePrecedePress = () => {
    setShowExtraFields(true);
    dispatch(checkIsEventModalNeededToOpen());
    onClose();
  }
  
  return (
    <Modal transparent={true} visible={visible} onRequestClose={onClose}>
      <View style={getStyles(['eventOverlay'])}>
      {showDetails ? (
          <View style={getStyles(['eventModalDetailContent'])}>

            <Text style={getStyles(['eventDetailsMainText'])}>
              {eventData.title}
            </Text>

            <Text style={getStyles(['eventDetailsDesc'])}>
              {eventData.description}
            </Text>

            {eventData.child_policy && (
              <>
                <Text style={getStyles(['sectionTitle'])}>{t('tableRes.child_policy')}</Text>
                <Text style={getStyles(['sectionText'])}>
                  {eventData.child_policy}
                </Text>
              </>
            )}

            {eventData.table_holding_policy && (
              <>
                <Text style={getStyles(['sectionTitle'])}>
                  {t('tableRes.table_holding_policy')}
                </Text>
                <Text style={getStyles(['sectionText'])}>
                  {eventData.table_holding_policy}
                </Text>
              </>
            )}

            {eventData.cuisine && (
              <Text style={getStyles(['inlineTitle'])}>
                <Text style={getStyles(['bold'])}>{t('tableRes.cuisine')} </Text>
                {eventData.cuisine}
              </Text>
            )}

            {eventData.dress_code && (
              <Text style={getStyles(['inlineTitle'])}>
                <Text style={getStyles(['bold'])}>{t('tableRes.dress_code')} </Text>
                {eventData.dress_code}
              </Text>
            )}

            {eventData.price_point && (
              <Text style={getStyles(['inlineTitle'])}>
                <Text style={getStyles(['bold'])}>{t('tableRes.price_point')} </Text>
                {eventData.price_point}
              </Text>
            )}

            <View style={getStyles(['eventModalDetailsBtnCont'])}>
              <CustomPressable
                style={getStyles(['tryAgainBtn'])}
                onPress={() => setShowDetails(false)}
              >
                <Text style={getStyles(['tryAgainModalBtnTxt'])}>{t('tableRes.back')}</Text>
              </CustomPressable>
            </View>
         </View>
        ) : (
            <View style={getStyles(['eventModalContent'])}>

            <Text style={getStyles(['eventModalTitle'])}>
             {t('tableRes.event_happening')}
            </Text>

            <Text style={getStyles(['eventText'])}>
              {eventData.title} {eventData.price_point}
            </Text>

            <CustomPressable
              style={getStyles(['eventDecsCont'])}
              onPress={() => setShowDetails(true)}
            >
              <Text
                style={getStyles(['eventDescription'])}
                numberOfLines={2}
                ellipsizeMode="tail"
              >
                {eventData.description}
              </Text>
              <ImageComp source={CHEVRON_RIGHT} />
            </CustomPressable>

            <View style={getStyles(['line'])} />

            <View style={getStyles(['eventInfoCont'])}>
              <Text style={getStyles(['eventInfoText'])}>
                {t('tableRes.event_happening_info')}
              </Text>
            </View>

            <View style={getStyles(['eventModalBtnCont'])}>
              <CustomPressable
                style={getStyles(['proceedBtn'])}
                onPress={handlePrecedePress} // Add your proceed logic here
              >
                <Text style={getStyles(['eventModalBtnTxt', 'proceedBtnText'])}>
                  {t('tableRes.proceed')}
                </Text>
              </CustomPressable>

              <CustomPressable style={getStyles(['closeBtn'])} onPress={onClose}>
                <Text style={getStyles(['closeBtnText'])}>{t('tableRes.close')}</Text>
              </CustomPressable>
            </View>
          </View>
        )}
      </View>
    </Modal>
  );
};

export default EventModal;
